<div class="flex">
  <span class="flex items-center gap-2 rounded-md bg-neutral-50 p-1 text-xs text-neutral-300 shadow-md">
    <span
      class="h-[6px] w-[6px] rounded p-1"
      [ngClass]="getColor(statusValue())"
    ></span>
    {{ statusMessage() }}
  </span>
</div>
